








/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../helpers";
// multiUserCreation
// MULTIUSERCREATION
const MULTIUSERCREATION= createAsyncThunk(
  "multiUserCreation/multiUserCreation",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const multiUserCreationSlice = createSlice({
  name: "multiUserCreationSlice",
  initialState: {
    multiUserCreation: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfmultiUserCreation: (state) => {
        state.multiUserCreation.loading = false
        state.multiUserCreation.error = false
        state.multiUserCreation.data = []
        state.multiUserCreation.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(MULTIUSERCREATION.fulfilled, (state, action) => {
      state.multiUserCreation = {
        ...state.multiUserCreation,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(MULTIUSERCREATION.pending, (state, action) => {
      state.multiUserCreation = {
        ...state.multiUserCreation,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(MULTIUSERCREATION.rejected, (state, action) => {
      state.multiUserCreation = {
        ...state.multiUserCreation,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const multiUserCreationAction = {
    MULTIUSERCREATION,
};

export { multiUserCreationAction };
export default multiUserCreationSlice.reducer;
export const {setInitialStateOfmultiUserCreation} = multiUserCreationSlice.actions
